import { map } from '@/helpers/lodash';
import SUPPORTED_PLATFORMS from '@/config/supported-platforms';

export const getSupportedPlatforms = ({ links } = {}) => map(
  SUPPORTED_PLATFORMS,
  (platformConfig) => {
    const { patterns } = platformConfig || {};

    const externalLinkObject = (links || []).find((l) => (patterns || []).some((pattern) => new RegExp(pattern, 'g').test(l.url || '')));

    if (!externalLinkObject) { return null; }

    return ({
      ...platformConfig,
      ...externalLinkObject
    });
  }
)
  .filter(_ => _);

export const getSupportedTicketPlatforms = ({ links } = {}) => getSupportedPlatforms({ links })
  .filter(({ isTicketLink }) => !!isTicketLink);

export const getTicketsPlatform = ({ links } = {}) => (getSupportedTicketPlatforms({ links }) || [])[0];